import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { IPOrganismosDashboardPage, IPOrganismosDetailPage } from '../components'

export const IPOrganismosRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<IPOrganismosDashboardPage />} />
      <Route path=":ipId" element={<IPOrganismosDetailPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}
